import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page48() {
  useEffect(() => {
    document.title = "Маяк — Страница 47"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page46" />
        <ForwardLink href="/page48" />
      </div>

      <p style={{ textAlign: "right" }}>47.</p>
      <p>Она поднимает руки, желая его объятий...</p>
      <p>МОЛОДОЙ открывает рот, чтобы в ужасе закричать...</p>
      <p>ФОГОРН ревет!</p>
      <p>
        МОЛОДОЙ убегает так быстро, как только может, размахивая руками<br/>
        и спотыкаясь. Он почти не контролирует свое тело, когда мчится<br/>
        через остров, его крики заглушает<br/>
        ФОГОРН.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ – НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>МОЛОДОЙ задыхается от криков. Глаза дикие.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Почему ты запыхаешься?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        От тебя пахнет дерьмом. Лучше всего убрать<br/>
        этот бардак до того, как тендер придет.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Делай, как я сказал, парень! Помещения<br/>
        ужасны.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – ПОЗЖЕ</p>
      <p>КАМБУЗ ЧИСТЫЙ. Ну, насколько это возможно.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КУБРИК – ПОЗЖЕ</p>
      <p>
        В КУБРИКЕ порядок. Матрасы свернуты. Все<br/>
        на своих местах. ЧАСЫ монотонно тикают.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. НЕДАЛЕКО ОТ БЕРЕГА – ПОЗЖЕ</p>
      <p>
        СТАРИК и МОЛОДОЙ в пальто, с мешками<br/>
        на плечах, с ящиками по бокам. Они смотрят<br/>
        на море, ожидая тендер.
      </p>
      <p style={{ textAlign: "right" }}>47.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page46" />
        <ForwardLink href="/page48" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710315391/the-lighthouse-script/rarvf9hgu5bai2z4hshd.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page48;
